export const RULES_RECEIVED = "RULES_RECEIVED";
export const RULES_RESET = "RULES_RESET";
export const MENU_RULES_RECEIVED = "MENU_RULES_RECEIVED";
export const MENU_RULES_RESET = "MENU_RULES_RESET";
